module.exports = __webpack_public_path__ + "img/tick.1bc58880.svg";